import {controller} from '@github/catalyst'

@controller
class SegmentedNavElement extends HTMLElement {
  changeTab(event: Event) {
    if (event.target === null) return
    const targetTabButton = event.target as HTMLElement
    const selectedTabSelector = targetTabButton.getAttribute('data-selected-tab')!
    const selectedTabs = this.querySelectorAll<HTMLElement>(`[data-tab="${selectedTabSelector}"]`)
    const selectedButtons = this.querySelectorAll<HTMLElement>(`[data-selected-tab="${selectedTabSelector}"]`)

    for (const selectedButton of selectedButtons) {
      for (const button of selectedButton.parentElement!.children) {
        button.classList.remove('selected')
        button.ariaSelected = 'false'
      }
    }

    for (const selectedButton of selectedButtons) {
      selectedButton.classList.add('selected')
      selectedButton.ariaSelected = 'true'
    }

    for (const selectedTab of selectedTabs) {
      for (const tab of selectedTab.parentElement!.children) {
        tab.classList.remove('active')
        tab.ariaSelected = 'false'
      }
    }

    for (const selectedTab of selectedTabs) {
      selectedTab.classList.add('active')
      selectedTab.ariaSelected = 'true'
    }
  }
}
